<template>
  <div>
    <FDBannerImg />
    <div class="navigation">
      <div class="page-cen">
        <div class="navigation-item">
          <a href="javascript:void(0)" @click="goPage('/home')">首页</a>
          &nbsp;&gt;
          <a href="javascript:void(0)" @click="goPage('/subjectresources')">学科资源</a>
          &nbsp;&gt;
          <a href="javascript:void(0)" @click="goPage('/subjectresources')">{{ id == 1 ? '系科资源' :'专题资源' }}</a>
          &nbsp;&gt;
          <a href="javascript:void(0)" class="active">{{ cname }}</a>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="content">
        <div class="library-resources">
          <div v-for="mod in modulesOrder" :key="mod.dictCode">
            
            <!-- 专家学者 -->
            <template v-if="mod.dictValue === '专家学者'">
              <Books />
            </template>

            <!-- 图书推荐 -->
            <template v-else-if="mod.dictValue === '图书推荐'">
           <div class="c-content">
            <div class="section-title">
                <div class="title-block">
                  <img src="./../../../assets/lzk/title-icon.png" alt="">
                </div>
                <h2>{{ mod.dictLabel }}</h2>
                <div class="language-switcher" @click="bookToggleLanguage">
                  <div class="lang-option" :class="{ active: bookCurrentLang === '1' }">中</div>
                  <div class="icon-wrapper">
                    <img src="./../../../assets/lzk/update-icon.png" alt="切换语言">
                  </div>
                  <div class="lang-option" :class="{ active: bookCurrentLang === '0' }">外</div>
                </div>
                <div class="more">
                  <u @click="findMoreBook">{{ isMoreBook ? '收起' : '查看更多' }}</u>
                </div>
              </div>
              <div class="book-recommendations">
                <div class="bookItem" v-for="item in bookLists" :key="item.id" @click="toDetail(item)">
                  <div class="imgBox">
                    <img :src="item.bookCover" :alt="item.bookTitle" />
                  </div>
                  <div class="infoBox">
                    <div class="title">{{ item.bookTitle }}</div>
                  </div>
                </div>
              </div>
           </div>
            </template>

            <!-- 期刊推荐 -->
            <template v-else-if="mod.dictValue === '期刊推荐'">
           <div class="c-content">

              <div class="section-title">
                <div class="title-block">
                  <img src="./../../../assets/lzk/title-icon.png" alt="">
                </div>
                <h2>{{ mod.dictLabel }}</h2>
                <div class="language-switcher" @click="journalToggleLanguage">
                  <div class="lang-option" :class="{ active: journalCurrentLang === '1' }">中</div>
                  <div class="icon-wrapper">
                    <img src="./../../../assets/lzk/update-icon.png" alt="切换语言">
                  </div>
                  <div class="lang-option" :class="{ active: journalCurrentLang === '0' }">外</div>
                </div>
                <div class="more">
                  <u @click="findMoreJournals">{{ isMoreJournal ? '收起' : '查看更多' }}</u>
                </div>
              </div>
              <div class="book-recommendations">
                <div class="bookItem" v-for="item in journalsLists" :key="item.id" @click="toJournalDetail(item)">
                  <div class="imgBox">
                    <img :src="item.cover" :alt="item.journalName" />
                  </div>
                  <div class="infoBox">
                    <div class="title">{{ item.journalName }}</div>
                  </div>
                </div>
              </div>
            </div>

            </template>

            <!-- 电子资源库 -->
            <template v-else-if="mod.dictValue === '电子资源库'">
           <div class="c-content">
              
              <div class="section-title">
                <div class="title-block">
                  <img src="./../../../assets/lzk/title-icon.png" alt="">
                </div>
                <h2>{{ mod.dictLabel }}</h2>
              </div>
              <div class="e-resources">
                <div>
                  <div class="resource-category">校内电子资源</div>
                  <div class="resource-item" v-for="(resource, index) in campusResources" :key="index">
                    <a :href="resource.resourceLink">{{ resource.resourceName }}</a>
                  </div>
                </div>
                <div>
                  <div class="resource-category">公共电子资源</div>
                  <div class="resource-item" v-for="(resource, index) in publicResources" :key="'pub' + index">
                    <a :href="resource.resourceLink">{{ resource.resourceName }}</a>
                  </div>
                </div>
              </div>
          </div>

            </template>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FDBannerImg from "@c/FDBannerImg";
import Books from "./../component/index.vue";
import { 
  getListByDepartmentResource, 
  getListBySpecialResource, 
  getListByDepartmentResourceJournal, 
  getListBySpecialResourceJournal, 
  getListByDepartmentResourceElectronicl, 
  getListBySpecialResourceElectronic,
  getListByDepartmentResourceScholarRecommend,
  getListBySpecialResourceScholarRecommend,
  getModelSorted
} from '@/lzk/api/subjectResource';

export default {
  name: "SubjectResource",
  components: { FDBannerImg, Books },
  data() {
    return {
      modulesOrder: [],
      bookList: [],
      journalsList: [],
      campusResources: [],
      publicResources: [],
      bookCurrentLang: '1',
      journalCurrentLang: '1',
      isMoreBook: false,
      isMoreJournal: false
    };
  },
  computed: {
    id() { return this.$route.params.id },
    cid() { return this.$route.params.cid },
    cname() { return this.$route.params.cname },
    bookLists() {
      return this.isMoreBook ? this.bookList : this.bookList.slice(0,5);
    },
    journalsLists() {
      return this.isMoreJournal ? this.journalsList : this.journalsList.slice(0,5);
    }
  },
  mounted() {
    this.loadModules();
  },
  methods: {
    async loadModules() {
      // 后端接口需要返回模块顺序数据
      const res = await getModelSorted()
      console.log(res,168168)
      this.modulesOrder = res.data.sort((a, b) => a.dictSort - b.dictSort);
      this.loadAllData();
    },
    async loadAllData() {
      await this.getBookData();
      await this.getJournalData();

      let electroniclData = [];
      if (this.id == 1) {
        await getListByDepartmentResourceScholarRecommend(this.cid);
        electroniclData = await getListByDepartmentResourceElectronicl(this.cid);
      } else {
        await getListBySpecialResourceScholarRecommend(this.cid);
        electroniclData = await getListBySpecialResourceElectronic(this.cid);
      }
      this.campusResources = electroniclData.data.filter(r => r.resourceType === '校内电子资源');
      this.publicResources = electroniclData.data.filter(r => r.resourceType !== '校内电子资源');
    },
    async getBookData() {
      const res = this.id == 1 
        ? await getListByDepartmentResource(this.cid, this.bookCurrentLang)
        : await getListBySpecialResource(this.cid, this.bookCurrentLang);
      this.bookList = res.data;
    },
    async getJournalData() {
      const res = this.id == 1 
        ? await getListByDepartmentResourceJournal(this.cid, this.journalCurrentLang)
        : await getListBySpecialResourceJournal(this.cid, this.journalCurrentLang);
      this.journalsList = res.data;
    },
    bookToggleLanguage() {
      this.bookCurrentLang = this.bookCurrentLang === '1' ? '0' : '1';
      this.getBookData();
    },
    journalToggleLanguage() {
      this.journalCurrentLang = this.journalCurrentLang === '1' ? '0' : '1';
      this.getJournalData();
    },
    findMoreBook() { this.isMoreBook = !this.isMoreBook },
    findMoreJournals() { this.isMoreJournal = !this.isMoreJournal },
    toDetail(item) {
      sessionStorage.setItem('bookDetail', JSON.stringify(item));
      this.$router.push({ path: `/subjectresources/bookdetail/${this.id}/${this.cid}/${this.cname}` });
    },
    toJournalDetail(item) {
      sessionStorage.setItem('journalDetail', JSON.stringify(item));
      this.$router.push({ path: `/subjectresources/journalDetail/${this.id}/${this.cid}/${this.cname}` });
    },
    goPage(url) { this.$router.push(url) }
  }
};
</script>




<style scoped lang="scss">
/* 样式保持不变 */
.banner_img {
  height: 220px;
  overflow: hidden;
  position: relative;
}

.container {
 

  .tag {
    display: flex;

    .tag_item {
      cursor: pointer;
      border: 1px solid #cdcdcd;
      background: #fff;
      font-size: 12px;
      color: #525252;
      line-height: 29px;
      padding: 0 18px;
      margin-right: 10px;
      border-radius: 20px;
    }

    .tag_item:hover,
    .active_tag {
      background-color: #004796;
      color: #fff;
    }
  }

  .content {}
}
.c-content{
  width: 1200px;
  margin: 20px auto;
  // padding-bottom: 96px;
  // min-height: 500px;
}
.library-resources {
  font-family: 'Microsoft YaHei', sans-serif;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  // box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.section-title {
  display: flex;
  align-items: center;
  margin: 30px 0 15px 0;

  .more {
    margin-left: auto;
    cursor: pointer;
  }
}

.title-block {
  width: 20px;
  height: 20px;
  background-color: #1a6dcc;
  margin-right: 10px;
}

.section-title h2 {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

/* 图书推荐样式 */
.book-recommendations {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
  margin-bottom: 30px;
}

.bookItem {
  cursor: pointer;
  padding: 0 18px;
  width: 100%;
  height: 272px;
  flex-direction: column;
  align-items: center;
  display: flex;
  margin-bottom: 20px;

  .imgBox {
    width: 170px;
    height: 240px;
    padding-top: 20px;
    text-align: center;

    img {
      height: 100%;
      width: 100%;
      border: 0;
    }
  }

  .infoBox {
    padding: 15px 2px 0;

    .title {
      height: 44px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
      color: #094d99;
      font-size: 14px;
      font-weight: 700;
      text-align: center;
    }

    .isbn {
      color: rgb(29, 126, 183);
      font-size: 14px;
    }

    p {
      color: #999;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.bookItem:hover .title {
  color: #1981f8;
}

.bookItem:last-child {
  margin-right: auto;
}

.info .info-item {
  padding: 4px 0px;
  font-size: 12px;
}

/* 期刊推荐样式 */
.journal-recommendations {
  margin-bottom: 30px;
}

.journal-item {
  padding: 12px 0;
  border-bottom: 1px solid #eee;
  position: relative;
}

.journal-name {
  font-size: 14px;
  color: #333;
  font-weight: bold;
}

.journal-subtitle {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

.journal-progress {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  color: #1a6dcc;
  font-weight: bold;
}

.view-more {
  text-align: right;
  margin-top: 10px;
  color: #1a6dcc;
  font-size: 14px;
  cursor: pointer;
}

/* 电子资源样式 */
.e-resources {
  margin-bottom: 30px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.resource-category {
  font-weight: bold;
  margin: 15px 0 10px 0;
  color: #333;
}

.resource-item {
  padding: 8px 0;
  font-size: 14px;
  color: #555;
  border-bottom: 1px dashed #eee;
}

.resource-item a:hover {
  color: #1a6dcc;
}

@media (max-width: 768px) {
  .book-recommendations {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .book-recommendations {
    grid-template-columns: 1fr;
  }
}
</style>
<style scoped>
.language-switcher {
  display: inline-flex;
  align-items: center;
  background-color: #e6f2ff;
  /* 浅蓝色背景 */
  /* padding: 6px 10px; */
  border-radius: 8px;
  cursor: pointer;
  user-select: none;
  transition: all 0.3s ease;
  margin-left: 10px;
}

.language-switcher:hover {
  background-color: #d6e8ff;
  /* 悬停时稍深的蓝色 */
}

.lang-option {
  padding: 6px 12px;
  font-size: 14px;
  color: #333;
  transition: all 0.3s ease;
}

.lang-option.active {
  background-color: #1a6dcc;
  /* 深蓝色 */
  color: white;
  border-radius: 6px;
  /* 圆角 */
  font-weight: 500;
}

.icon-wrapper {
  padding: 0 4px;
  display: flex;
  align-items: center;
}

.icon-wrapper img {
  width: 16px;
  height: 16px;
  opacity: 0.7;
  transition: all 0.3s ease;
}

.language-switcher:hover .icon-wrapper img {
  opacity: 1;
  transform: rotate(180deg);
  /* 悬停时图标旋转效果 */
}
</style>